/** * Footer Mobile Accordion Menu. 
 * 
 * @package  DGD Platinum 
 * @since    1.0.0 
 */

function initMobileFooterMenu() {
    const footerMenu = document.querySelector('.footer-menu');
    const menuItems = footerMenu.querySelectorAll('.menu-item.menu-item-has-children');
    menuItems.forEach((menuItem) => {
        const menuTrigger = menuItem.querySelector('.menu-item__trigger');        
        menuTrigger.addEventListener('click', function () {            
            const currentMenuItem = this.parentNode;            
            const currentSubMenu = this.nextElementSibling;            
            if (currentMenuItem.classList.contains('open') && currentSubMenu.className === 'sub-menu__down') {
                currentMenuItem.classList.remove('open');                
                currentSubMenu.className = 'sub-menu';            
            } else {                
                currentMenuItem.classList.add('open');                
                currentSubMenu.className = 'sub-menu__down';            
            }        
        });    
    });
}

window.addEventListener('DOMContentLoaded', initMobileFooterMenu);